import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const AuthLayout = () => {
  const location = useLocation();
  const pathName = location.pathname;
  const authRoutes = ["/", "/forgot-password", "/enter-otp", "/reset-password"];

  return (
    <>
      {authRoutes.includes(pathName) ? (
        <>
          <Outlet />
        </>
      ) : (
        <>
          <main className="main" id="main">
            <div className="">
              <Outlet />
            </div>
          </main>
        </>
      )}
    </>
  );
};

export default AuthLayout;
